/**
 * Admin Base URL Configuration
 * Returns the admin base URL from environment variable.
 *
 * Usage in .env files:
 * - .env.development: REACT_APP_ADMIN_BASE_URL=https://mabel.admin.dev.byod.ai
 * - .env.staging: REACT_APP_ADMIN_BASE_URL=https://mabel.admin.stage.byod.ai
 * - .env.production: REACT_APP_ADMIN_BASE_URL=https://mabel.admin.prod.byod.ai
 *
 * OPS-004: never fall back to a staging host when the env var is missing.
 */
export const getAdminBaseUrl = (): string => {
	const url = process.env.REACT_APP_ADMIN_BASE_URL?.trim();
	if (!url) {
		throw new Error(
			'REACT_APP_ADMIN_BASE_URL is not set. Configure it in the environment file for this build.'
		);
	}
	return url;
};
